import React, {
  useRef,
  useState,
  useEffect,
  ChangeEvent,
  DragEvent,
} from "react";
import FileuploadIcon from "../../assets/images/fileUpload.svg";
import "./fileUpload.css";

const FileUpload = ({
  accept,
  onChange,
  onClearImage,
  fileUrl = null,
  error,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (fileUrl) {
      const extractedFileName = fileUrl.split("/").pop();
      setFileName(extractedFileName || "");
    } else {
      setFileName("");
    }
  }, [fileUrl]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    handleFile(file);
  };

  const handleFile = (file) => {
    if (file) {
      setFileName(file.name);
      onChange(file);
    } else {
      setFileName("");
      onChange(null);
    }
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="file-upload-container">
      <div
        className={`drop-area ${isDragging ? "dragging" : ""}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <input
          type="file"
          ref={fileInputRef}
          accept={accept}
          onChange={handleFileChange}
          className="hidden-input"
        />
        <div className="content">
          <img src={FileuploadIcon} />
          <p className="upload-text">
            Drop your image here, or <span className="browse-text">browse</span>
          </p>
          <p className="file-types"> PNG (Below 2 MB)</p>
        </div>
      </div>
      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default FileUpload;
